export const login = {
	state: {
		user: null,
		userLoggedIn: null,
	},
	mutations: {
		initChangePassword: (state) => {
			state.changePassword = {
				Email: '',
				OldPassword: '',
				NewPassword: '',
				ConfirmPassword: '',
			};
		},
		setCurrentUser(state, user) {
			state.user = user;
			sessionStorage.setItem('loggedIn', true);
		},
		logoutUser: (state) => {
			state.user = null;
			sessionStorage.removeItem('loggedIn', true);
		},
	},
	actions: { },
	getters: {
		user: (state) => {
			return state.user;
		},
		userLoggedIn: (state) => {
			return state.user || sessionStorage.getItem('loggedIn');
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/modules/Login.js